import { Button, ListItemText, Select } from '@material-ui/core'
import injectStyles from 'react-jss'

import { Chip, MenuItem } from 'material-ui'
import React from 'react'
import { styles } from './styles'
import classNames from 'classnames'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: () => null,
}

const Multiselect = ({
  selectedCities,
  setSelectedCities,
  citiesList,
  title,
  placeholder,
  customSelectStyle,
  chipContainerStyle,
  customContainerStyle,
  hideClearButton,
  classes,
}) => {
  const onClear = () => {
    setSelectedCities(['All'])
  }

  return (
    <div className={classes.selectWrapper}>
      <div
        className={classNames({
          [classes.selectWithChip]: true,
          [customContainerStyle]: true,
        })}
      >
        <div className={classes.selectContainer}>
          <div
            className={classes.cityTitle}
            cypress_id={'cityFilterTitleOnChatSidebar'}
          >
            {title}
          </div>

          <div
            className={classes.citySelectContainer}
            cypress_id={'cityFilterOnChatSidebar'}
          >
            <Select
              multiple
              label="City:"
              disableUnderline
              value={selectedCities}
              onChange={event => {
                if (
                  event.target.value[event.target.value.length - 1] === 'All'
                ) {
                  return setSelectedCities(['All'])
                }
                if (
                  event.target.value.length > 1 &&
                  event.target.value.includes('All')
                ) {
                  return setSelectedCities(
                    event.target.value.filter(item => item !== 'All'),
                  )
                }

                if (event.target.value.includes('All')) {
                  return setSelectedCities(['All'])
                }
                setSelectedCities(event.target.value)
              }}
              renderValue={selected => ''}
              style={{
                width: 270,
                height: 36,
                border: 'none',
                paddingRight: 6,
                ...customSelectStyle,
              }}
              MenuProps={MenuProps}
            >
              <MenuItem
                key={'All'}
                value={'All'}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <ListItemText primary={'All'} />
              </MenuItem>
              {citiesList.map(city => (
                <MenuItem
                  key={city}
                  value={city}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: 16,
                    fontFamily: "'Proxima Nova', sans-serif",
                    backgroundColor:
                      selectedCities.indexOf(city) > -1
                        ? '#E2E2FC'
                        : 'transparent',
                  }}
                >
                  {city}
                </MenuItem>
              ))}
            </Select>
            <span className={classes.placeholder}>
              {selectedCities.includes('All') ? 'All' : placeholder}
            </span>
          </div>
        </div>
        <div
          id="chip-list"
          className={classNames({
            [classes.chipContainer]: true,
            [chipContainerStyle]: true,
          })}
        >
          {selectedCities.map(item => {
            if (item === 'All') return null
            return (
              <Chip
                size={'small'}
                style={{
                  marginLeft: 14,
                  borderRadius: 4,
                  border: `1px solid #E2E2FC`,
                  fontSize: 16,
                  fontFamily: "'Proxima Nova', sans-serif",
                  color: '#011533',
                  backgroundColor: '#E2E2FC',
                  marginBottom: 14,
                }}
                label={item}
                onRequestDelete={() => {
                  const city = selectedCities.filter(
                    selectedCity => selectedCity !== item,
                  )
                  setSelectedCities(city)
                }}
              >
                {item}
              </Chip>
            )
          })}
        </div>
      </div>

      {selectedCities.includes('All') ||
      selectedCities.length === 0 ||
      hideClearButton ? null : (
        <div className={classes.button}>
          <Button
            color="secondary"
            size="small"
            onClick={onClear}
            style={{
              textTransform: 'none',
              fontSize: 16,
              fontFamily: "'Proxima Nova', sans-serif",
              marginTop: 24,
              marginLeft: 10,
              color: '#273754',
              fontWeight: '700',
              minWidth: 80,
            }}
            disabled={
              selectedCities.includes('All') || selectedCities.length === 0
            }
          >
            Clear all
          </Button>
        </div>
      )}
    </div>
  )
}

export default injectStyles(styles)(Multiselect)
